import styled from "styled-components";

export const AddressResultWrapper = styled.li`
    display: flex;
    align-items: center;
    width: 100%;
    padding: var(--spacing-2);
    background-color: var(--color-white);
    transition: background-color 0.3s;
    cursor: pointer;
    &:is(:hover, :focus) {
        background: var(--color-cloud);
    }
`;

export const AddressResultEllipsis = styled.span`
    display: inline-block;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;
